var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavOpen = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M15 13H5a1 1 0 0 1 0-2h10V8l5 4-5 4zm-3 4a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2zm0-12a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2z"
})));
export default SvgNavOpen;